module.exports = __webpack_public_path__ + "static/media/velour6D.a2337d1b.jpg";